/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_FamilyGroupPickerChildDTO } from './billing_FamilyGroupPickerChildDTO';
import type { billing_FamilyGroupPickerMemberDTO } from './billing_FamilyGroupPickerMemberDTO';
export type billing_FamilyGroupPickerItemDTO = {
    billingType: billing_FamilyGroupPickerItemDTO.billingType;
    children: Array<billing_FamilyGroupPickerChildDTO>;
    debtorAccountId?: string;
    familyName: string;
    id: string;
    lifecycle: billing_FamilyGroupPickerItemDTO.lifecycle;
    members: Array<billing_FamilyGroupPickerMemberDTO>;
    netBalanceCents: number;
    sharesParent: boolean;
    totalOutstandingCents: number;
    unappliedCreditCents: number;
    unifiedBillingEmail?: string;
};
export namespace billing_FamilyGroupPickerItemDTO {
    export enum billingType {
        UNIFIED = 'UNIFIED',
        SPLIT = 'SPLIT',
    }
    export enum lifecycle {
        CURRENT = 'current',
        LEFT = 'left',
        NONE = 'none',
    }
}

